import { useSetAtom } from 'jotai';
import { SyntheticEvent } from 'react';
import { IStepsBlock } from '@sapientpro/sapientpro-data-models';
import contactModalTriggerButton from '../../store/contactForm';
import styles from './HowWeWork.module.scss';
import { GAEmit, GAEvents } from '../../gtagHelper';
import Button, { ButtonVariants } from '../../components/Button';

const HowWeWorkContactButton = ({ ctaButton }: { ctaButton: IStepsBlock['ctaButton'] }) => {
  const setContactsModalTrigger = useSetAtom(contactModalTriggerButton);

  const handleHowWeWorkClick = (event: SyntheticEvent) => {
    setContactsModalTrigger(`${(event.target as HTMLElement).innerText} | How We Work section`);
    GAEmit(GAEvents.startYourProjectClick);
  };

  const buttonText = ctaButton || 'start your project';

  return (
    <Button
      variant={ButtonVariants.OUTLINED}
      className={styles.howWeWork__button}
      icon={(
        <svg>
          <use
            xlinkHref='/media/icon-nest.svg#iconNest'
            href='/media/icon-nest.svg#iconNest'
          />
        </svg>
          )}
      iconPosition='right'
      iconSize={{ width: 24, height: 24 }}
      size='medium'
      onClick={handleHowWeWorkClick}
    >
      {buttonText}
    </Button>
  );
};

export default HowWeWorkContactButton;
